// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bfz_a bhe_un bhe_cw bhe_a","MenuItem__Btn":"bfz_b bhe_z"};